import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CopyrightBarComponent } from '../copyright-bar/copyright-bar.component';

@Component({
    selector: 'app-footer',
    standalone: true,
    imports: [CommonModule, CopyrightBarComponent],
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
    @Input() currentYear: number = new Date().getFullYear();
}
